import { useTheme } from "../../styles/theme";
import { useApp } from "../../context/AppContext";

export default function Auth() {
  const S = useTheme();
  const c = S.colors;
  const {
    authMode,
    setAuthMode,
    authForm,
    setAuthForm,
    authError,
    setAuthError,
    authSubmitting,
    handleAuthSubmit,
  } = useApp();

  return (
    <div
      style={{
        ...S.root,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <div style={S.bgGrid} />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          maxWidth: 420,
          margin: "0 auto",
          padding: "0 16px",
        }}
      >
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>₹</div>
          <div
            style={{
              fontSize: 26,
              fontWeight: 800,
              color: c.text,
              letterSpacing: "-0.5px",
            }}
          >
            ProfitLens
          </div>
          <div style={{ fontSize: 13, color: c.textFaint, marginTop: 4 }}>
            Daily P&L · Vendor Credit · Debt Manager
          </div>
        </div>

        {/* Auth card */}
        <div
          style={{
            background: c.surface,
            border: `1px solid ${c.border}`,
            borderRadius: 18,
            padding: "28px 28px 24px",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 0,
              marginBottom: 24,
              background: c.surfaceAlt,
              borderRadius: 10,
              padding: 4,
            }}
          >
            {["login", "register"].map((mode) => (
              <button
                key={mode}
                onClick={() => {
                  setAuthMode(mode);
                  setAuthError("");
                }}
                style={{
                  flex: 1,
                  border: "none",
                  borderRadius: 8,
                  padding: "9px 0",
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: "pointer",
                  transition: "all 0.2s",
                  background: authMode === mode ? c.warn : "transparent",
                  color: authMode === mode ? c.onWarn : c.textFaint,
                }}
              >
                {mode === "login" ? "Sign In" : "Create Account"}
              </button>
            ))}
          </div>

          <form
            onSubmit={handleAuthSubmit}
            style={{ display: "flex", flexDirection: "column", gap: 14 }}
          >
            {authMode === "register" && (
              <div style={S.formField}>
                <label style={S.label}>Full Name</label>
                <input
                  style={S.input}
                  type="text"
                  placeholder="Your name"
                  value={authForm.name}
                  onChange={(e) =>
                    setAuthForm((f) => ({ ...f, name: e.target.value }))
                  }
                  required
                />
              </div>
            )}
            <div style={S.formField}>
              <label style={S.label}>Email</label>
              <input
                style={S.input}
                type="email"
                placeholder="you@example.com"
                value={authForm.email}
                onChange={(e) =>
                  setAuthForm((f) => ({ ...f, email: e.target.value }))
                }
                required
              />
            </div>
            <div style={S.formField}>
              <label style={S.label}>Password</label>
              <input
                style={S.input}
                type="password"
                placeholder={
                  authMode === "register" ? "Min 6 characters" : "Your password"
                }
                value={authForm.password}
                onChange={(e) =>
                  setAuthForm((f) => ({ ...f, password: e.target.value }))
                }
                required
              />
            </div>

            {authError && (
              <div
                style={{
                  background: c.dangerBg,
                  border: `1px solid ${c.dangerBorder}`,
                  borderRadius: 8,
                  padding: "10px 14px",
                  color: c.dangerLight,
                  fontSize: 13,
                }}
              >
                {authError}
              </div>
            )}

            <button
              type="submit"
              disabled={authSubmitting}
              style={{
                ...S.submitBtn,
                width: "100%",
                marginTop: 4,
                opacity: authSubmitting ? 0.6 : 1,
              }}
            >
              {authSubmitting
                ? "Please wait..."
                : authMode === "login"
                  ? "Sign In"
                  : "Create Account"}
            </button>
          </form>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: 20,
            fontSize: 12,
            color: c.textWhisper,
          }}
        >
          ProfitLens · Your business, your numbers
        </div>
      </div>
    </div>
  );
}
